import { rest } from "msw";
import { shop } from "~@/mocks/data/shop";
const shopHandler = rest.get("/shop-pagination", (req, res, ctx) => {
  const params: URLSearchParams = req.url.searchParams;
  return res(
    ctx.status(200),
    ctx.json({
      data: {
        records: shop,
        currentPage: Number(params.get("page")),
        pageSize: Number(params.get("pageSize")),
        totalPages:
          shop.length > Number(params.get("pageSize"))
            ? Math.ceil(shop.length / Number(params.get("pageSize")))
            : 1,
        totalSize: shop.length,
      },
      errorCode: 200,
      message: "",
    })
  );
});

export default shopHandler;
